import React from 'react';
import type IconType from './iconType';

export default function CloneIcon({ color = '#7F38E9', width = 20, height = 20, ...rest }: IconType) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M1.66406 9.99935C1.66406 6.07098 1.66406 4.10679 2.88445 2.8864C4.10484 1.66602 6.06902 1.66602 9.99739 1.66602C13.9258 1.66602 15.8899 1.66602 17.1103 2.8864C18.3307 4.10679 18.3307 6.07098 18.3307 9.99935"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M1.66797 12.165C1.66797 10.007 1.66797 8.92807 2.12211 8.10384C2.52158 7.37883 3.159 6.78938 3.94301 6.41997C4.83431 6 6.00108 6 8.33463 6H11.668C14.0015 6 15.1683 6 16.0596 6.41997C16.8436 6.78938 17.481 7.37883 17.8805 8.10384C18.3346 8.92807 18.3346 10.007 18.3346 12.165C18.3346 14.323 18.3346 15.4019 17.8805 16.2262C17.481 16.9512 16.8436 17.5406 16.0596 17.91C15.1683 18.33 14.0015 18.33 11.668 18.33H8.33463C6.00108 18.33 4.83431 18.33 3.94301 17.91C3.159 17.5406 2.52158 16.9512 2.12211 16.2262C1.66797 15.4019 1.66797 14.323 1.66797 12.165Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M12.5 12H10M10 12L7.5 12M10 12L10 9.5M10 12L10 14.5"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
